import React, { useEffect, useState } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

export default function MultiSelectFilterCell(props) {
  const data = props.data || [];

  const [stateValue, setStateValue] = useState([]);

  useEffect(() => {
    if (props.value && Array.isArray(props.value)) {
      setStateValue(props.value);
    }
  }, [props.value]);

  const multiSelectFilterOperator = (value, current) => {
    return (
      !value ||
      !value.length ||
      value.includes("Not Selected") ||
      value.includes(current)
    );
  };

  const handleChange = (event) => {
    const selectedValues = event.target.value;
    setStateValue(selectedValues);

    props.onChange({
      value: selectedValues,
      operator: multiSelectFilterOperator.bind(undefined, selectedValues),
      syntheticEvent: event.syntheticEvent,
    });
  };

  return (
    <div className="k-filtercell">
      <MultiSelect
        data={data}
        value={stateValue}
        onChange={handleChange}
        autoClose={false}
        placeholder="Çoklu Seçim Yapabilirsiniz"
      />
    </div>
  );
}
